import { payloadBuilder } from ".";

export const formHelper = {
  isFunction(param) {
    return typeof param === "function";
  },

  emptyFunction() {},

  normalize(v) {
    if (!v) return "";
    // if ValidatedForm Object {value, isValid, message}
    if (typeof v === "object" && v.value !== undefined) {
      return v.value;
    }
    return v;
  },

  formDataBuilder(state, fileFields = []) {
    const formData = new FormData();

    const payload = payloadBuilder(state);

    for (const [key, value] of Object.entries(payload)) {
      if (value !== null && value !== undefined && !fileFields.includes(key)) {
        formData.append(key, value);
      }
    }

    fileFields.forEach((field) => {
      const item = state[field];

      const file = item && item.value !== undefined ? item.value : item;

      if (file) {
        formData.append("file", file);
      }
    });

    return formData;
  },
};
